import Tasks from 'APP/Tasks';
import { messageModel } from 'APP/model/model';
import Entities from 'STORE';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

export async function loadMessagesByIds(
  groupId: string,
  messagesIds: string[]
): Promise<ChatMessage[]> {
  const group = Entities.GroupsStore.getGroupById(groupId);
  if (!group) {
    return [];
  }

  try {
    const messages = await messageModel.getMessagesByIds(groupId, messagesIds);

    Tasks.messaging.updateOldOrFakeMessages({ groupId, messages });

    const loadedMessages: ChatMessage[] = [];
    messagesIds.forEach((id) => {
      const message = group.messagesStore.getMessageById(id);
      if (message) {
        loadedMessages.push(message);
      }
    });

    return loadedMessages;
  } catch {
    return [];
  }
}
